import { supabase } from '../config/supabase';

// ── الترجمات الافتراضية ────────────────────────────────────
const DEFAULTS = (lang, site) => ({
  site: site || 'الجوهرة',
  subtitle: lang === 'ar' ? 'منصة متكاملة للتعليم والخدمات الاحترافية' : 'Integrated Platform for Education and Professional Services',
  academy: lang === 'ar' ? 'الأكاديمية' : 'Academy',
  academyDesc: lang === 'ar' ? 'كورسات احترافية في مختلف المجالات' : 'Professional courses in various fields',
  agency: lang === 'ar' ? 'الأجنسي' : 'Agency',
  agencyDesc: lang === 'ar' ? 'خدمات تطوير المواقع والتطبيقات' : 'Web, app development and marketing',
  contact: lang === 'ar' ? 'تواصل معنا' : 'Contact Us',
  contactDesc: lang === 'ar' ? 'نحن هنا للمساعدة' : 'We are here to help',
  custLogin: lang === 'ar' ? 'دخول العملاء' : 'Customer Login',
  custRegister: lang === 'ar' ? 'حساب جديد' : 'New Account',
  guestLabel: lang === 'ar' ? 'زائر' : 'Guest',
  guestWelcome: lang === 'ar' ? 'تصفح كزائر 👀' : 'Browse as Guest 👀',
  guestSubtitle: lang === 'ar' ? 'اسمك ورقمك بس' : 'Just name & phone',
  guestNote: lang === 'ar' ? 'كزائر تقدر تشوف خدماتنا وكورساتنا. لو حبيت تشترك في كورس، سجّل حساب كامل.' : 'As a guest you can browse. To enroll, create a full account.',
  guestBtn: lang === 'ar' ? 'دخول كزائر' : 'Enter as Guest',
  logout: lang === 'ar' ? 'تسجيل خروج' : 'Logout',
  name: lang === 'ar' ? 'الاسم' : 'Name',
  email: lang === 'ar' ? 'البريد الإلكتروني' : 'Email',
  phone: lang === 'ar' ? 'رقم التليفون' : 'Phone',
  password: lang === 'ar' ? 'كلمة المرور' : 'Password',
  enterName: lang === 'ar' ? 'أدخل اسمك' : 'Enter your name',
  enterEmail: lang === 'ar' ? 'أدخل بريدك' : 'Enter your email',
  enterPhone: lang === 'ar' ? 'أدخل رقم تليفونك' : 'Enter your phone',
  loginBtn: lang === 'ar' ? 'دخول' : 'Login',
  registerBtn: lang === 'ar' ? 'إنشاء حساب' : 'Create Account',
  custWelcome: lang === 'ar' ? 'أهلاً بك 👋' : 'Welcome Back 👋',
  custWelcomeReg: lang === 'ar' ? 'إنشاء حساب جديد 🎉' : 'Create Account 🎉',
  custSubtitle: lang === 'ar' ? 'سجل دخولك لمتابعة كورساتك' : 'Login to track your courses',
  custSubtitleReg: lang === 'ar' ? 'انضم إلى مجتمع الجوهرة' : 'Join the Al-Jawhara community',
  wrongCust: lang === 'ar' ? 'البريد أو كلمة المرور غلط' : 'Wrong email or password',
  emailTaken: lang === 'ar' ? 'البريد مسجل مسبقاً' : 'Email already registered',
  custOk: lang === 'ar' ? 'تم تسجيل الدخول!' : 'Logged in!',
  regOk: lang === 'ar' ? 'تم إنشاء الحساب!' : 'Account created!',
  empLogin: lang === 'ar' ? 'دخول الموظفين' : 'Employee Login',
  empSubtitle: lang === 'ar' ? 'منطقة مقيدة — موظفون فقط' : 'Restricted Area — Staff Only',
  username: lang === 'ar' ? 'اسم المستخدم' : 'Username',
  enterUsername: lang === 'ar' ? 'أدخل اسم المستخدم' : 'Enter username',
  wrongEmp: lang === 'ar' ? 'بيانات غير صحيحة أو الحساب موقوف' : 'Invalid credentials or account suspended',
  empOk: lang === 'ar' ? 'مرحباً! جاري الدخول...' : 'Welcome! Redirecting...',
  dashboard: lang === 'ar' ? 'لوحة التحكم' : 'Dashboard',
  allCourses: lang === 'ar' ? 'جميع الكورسات' : 'All Courses',
  enrollNow: lang === 'ar' ? 'اشترك الآن' : 'Enroll Now',
  allServices: lang === 'ar' ? 'خدماتنا' : 'Our Services',
  requestService: lang === 'ar' ? 'اطلب الخدمة' : 'Request Service',
  aiAssistant: lang === 'ar' ? 'المساعد الذكي' : 'AI Assistant',
  askQ: lang === 'ar' ? 'اسأل أي سؤال...' : 'Ask any question...',
  backHome: lang === 'ar' ? 'العودة للرئيسية' : 'Back to Home',

  // ── المدربون / التصنيفات / البحث (صفحة الأكاديمية والمدربين) ──
  instructorsTitle: lang === 'ar' ? 'المدربون' : 'Instructors',
  instructorsCount: lang === 'ar' ? 'مدرب' : 'instructors',
  allInstructors:   lang === 'ar' ? 'كل المدربين' : 'All Instructors',
  noInstructors:    lang === 'ar' ? 'لا يوجد مدربون بعد' : 'No instructors yet',
  noInstructorMatch: lang === 'ar' ? 'مفيش مدرب بالاسم ده' : 'No instructor matches',
  instructorCourses: lang === 'ar' ? 'كورسات المدرب' : 'Courses',
  noInstructorCourses: lang === 'ar' ? 'لا توجد كورسات لهذا المدرب بعد.' : 'No courses yet.',
  aboutLabel:       lang === 'ar' ? 'نبذة' : 'About',
  experienceLabel:  lang === 'ar' ? 'الخبرات' : 'Experience',
  searchInstructor: lang === 'ar' ? 'ابحث باسم المدرب أو التخصص...' : 'Search by instructor name...',
  searchCourse:     lang === 'ar' ? 'ابحث باسم الكورس أو المدرب...' : 'Search course or instructor...',
  coursesAvailable: lang === 'ar' ? 'كورس متاح' : 'courses available',
  filtersLabel:     lang === 'ar' ? 'فلاتر' : 'Filters',
  clearFilters:     lang === 'ar' ? 'مسح الفلاتر' : 'Clear filters',
  noMatchingCourses: lang === 'ar' ? 'لا توجد كورسات مطابقة' : 'No matching courses',
  tryChangeSearch:  lang === 'ar' ? 'جرّب تغيير كلمة البحث أو الفلاتر' : 'Try changing your search or filters',
  typeLabel:        lang === 'ar' ? 'النوع' : 'Type',
  allLabel:         lang === 'ar' ? 'الكل' : 'All',
  paidLabel:        lang === 'ar' ? 'مدفوع' : 'Paid',
  anyLabel:         lang === 'ar' ? 'بدون' : 'Any',
  greaterThan:      lang === 'ar' ? 'أكبر من' : 'Greater than',
  lessThan:         lang === 'ar' ? 'أصغر من' : 'Less than',
  equalsLabel:      lang === 'ar' ? 'يساوي' : 'Equals',
  newBadge:         lang === 'ar' ? 'جديد' : 'New',
  egpLabel:         lang === 'ar' ? 'جنيه' : 'EGP',
  detailsBtn:       lang === 'ar' ? 'التفاصيل' : 'Details',
  watchBtn:         lang === 'ar' ? 'شاهد' : 'Watch',
  courseWord:       lang === 'ar' ? 'كورس' : 'courses',
  // أعمال الطلاب وآراء الطلاب
  studentWorksTitle: lang === 'ar' ? 'أعمال طلاب هذا الكورس' : 'Student Works',
  noStudentWorks:   lang === 'ar' ? 'لسه ما فيش أعمال طلاب — تابعونا قريبًا!' : 'No student works yet — stay tuned!',
  reviewsTitle:     lang === 'ar' ? 'آراء الطلاب' : 'Student Reviews',
  rateCourse:       lang === 'ar' ? 'قيّم الكورس' : 'Rate this course',
  enrollFirstReview: lang === 'ar' ? 'لازم تشترك في الكورس الأول عشان تقدر تقيّمه ⭐' : 'Enroll in this course first to leave a review ⭐',
  reviewPending:    lang === 'ar' ? 'شكرًا! رأيك هيظهر بعد موافقة الإدارة ✓' : 'Thanks! Your review will appear after approval ✓',
  alreadyReviewed:  lang === 'ar' ? 'سجّلت رأيك في الكورس ده قبل كده ✓' : 'You already reviewed this course ✓',
  newCourseBadge:   lang === 'ar' ? 'كورس جديد' : 'New',
  studentsWord:     lang === 'ar' ? 'طالب' : 'students',
  lessonWord:       lang === 'ar' ? 'حلقة' : 'lessons',

  aiHi: lang === 'ar' ? 'مرحباً! أنا المساعد الذكي للجوهرة.' : "Hello! I'm Al-Jawhara's AI assistant.",
  manageCourses: lang === 'ar' ? 'إدارة الكورسات' : 'Manage Courses',
  manageServices: lang === 'ar' ? 'إدارة الخدمات' : 'Manage Services',
  addCourse: lang === 'ar' ? 'إضافة كورس' : 'Add Course',
  editCourse: lang === 'ar' ? 'تعديل كورس' : 'Edit Course',
  addService: lang === 'ar' ? 'إضافة خدمة' : 'Add Service',
  editService: lang === 'ar' ? 'تعديل خدمة' : 'Edit Service',
  addLesson: lang === 'ar' ? 'إضافة حلقة' : 'Add Lesson',
  editLesson: lang === 'ar' ? 'تعديل حلقة' : 'Edit Lesson',
  manageLessons: lang === 'ar' ? 'إدارة الحلقات' : 'Manage Lessons',
  nameAr: lang === 'ar' ? 'الاسم بالعربي' : 'Name (Arabic)',
  nameEn: lang === 'ar' ? 'الاسم بالإنجليزي' : 'Name (English)',
  titleAr: lang === 'ar' ? 'عنوان الحلقة بالعربي' : 'Lesson Title (Arabic)',
  titleEn: lang === 'ar' ? 'عنوان الحلقة بالإنجليزي' : 'Lesson Title (English)',
  price: lang === 'ar' ? 'السعر' : 'Price',
  icon: lang === 'ar' ? 'الأيقونة' : 'Icon',
  save: lang === 'ar' ? 'حفظ' : 'Save',
  cancel: lang === 'ar' ? 'إلغاء' : 'Cancel',
  from: lang === 'ar' ? 'من' : 'From',
  driveId: lang === 'ar' ? 'رابط الفيديو (Vimeo / YouTube)' : 'Video URL (Vimeo / YouTube)',
  driveIntro: lang === 'ar' ? 'رابط الفيديو التشويقي (Vimeo / YouTube)' : 'Intro Video URL (Vimeo / YouTube)',
  duration: lang === 'ar' ? 'المدة (مثال: 15:30)' : 'Duration (e.g. 15:30)',
  orderNum: lang === 'ar' ? 'الترتيب' : 'Order',
  isFree: lang === 'ar' ? 'معاينة مجانية؟' : 'Free Preview?',
  generalSettings: lang === 'ar' ? 'إعدادات الموقع' : 'Site Settings',
  siteName: lang === 'ar' ? 'اسم الموقع' : 'Site Name',
  whatsappNumber: lang === 'ar' ? 'رقم الواتساب' : 'WhatsApp Number',
  whatsappMessage: lang === 'ar' ? 'رسالة الواتساب' : 'WhatsApp Message',
  vodafoneNumber: lang === 'ar' ? 'رقم فودافون كاش' : 'Vodafone Cash Number',
  instapayNumber: lang === 'ar' ? 'رقم InstaPay' : 'InstaPay Number',
  bankAccount: lang === 'ar' ? 'بيانات الحساب البنكي' : 'Bank Account Details',
  coursesLabel: lang === 'ar' ? 'الكورسات' : 'Courses',
  servicesLabel: lang === 'ar' ? 'الخدمات' : 'Services',
  customersLabel: lang === 'ar' ? 'العملاء' : 'Customers',
  enrollmentsLabel: lang === 'ar' ? 'الاشتراكات' : 'Enrollments',
  confirmDel: lang === 'ar' ? 'هل أنت متأكد من الحذف؟' : 'Are you sure?',
  haveAccount: lang === 'ar' ? 'عندك حساب؟' : 'Have an account?',
  noAccount: lang === 'ar' ? 'مش عندك حساب؟' : "Don't have an account?",
  saving: lang === 'ar' ? 'جاري الحفظ...' : 'Saving...',
  payTitle: lang === 'ar' ? 'اختر طريقة الدفع' : 'Choose Payment Method',
  payCard: lang === 'ar' ? 'فيزا / ماستركارد' : 'Visa / Mastercard',
  payWallet: lang === 'ar' ? 'فودافون كاش' : 'Vodafone Cash',
  payTransfer: lang === 'ar' ? 'تحويل بنكي / InstaPay' : 'Bank Transfer / InstaPay',
  payCardDesc: lang === 'ar' ? 'دفع فوري وتفعيل أوتوماتيك' : 'Instant payment and activation',
  payWalletDesc: lang === 'ar' ? 'ادفع وابعت إيصال' : 'Pay and send receipt',
  payTransferDesc: lang === 'ar' ? 'حوّل وابعت صورة الإيصال' : 'Transfer and send receipt',
  payNow: lang === 'ar' ? 'ادفع الآن' : 'Pay Now',
  sendReceipt: lang === 'ar' ? 'أرسل الإيصال للمراجعة' : 'Send Receipt for Review',
  receiptNote: lang === 'ar' ? 'رقم المعاملة' : 'Transaction Note',
  enterNote: lang === 'ar' ? 'أدخل رقم المعاملة' : 'Enter transaction ID',
  pendingMsg: lang === 'ar' ? 'تم استلام طلبك! سيتم تفعيل الكورس بعد مراجعة الدفع.' : 'Request received! Course will be activated after payment review.',
  loginFirst: lang === 'ar' ? 'سجل دخولك أولاً للاشتراك' : 'Please login first to enroll',
  enrolled: lang === 'ar' ? 'مشترك ✓' : 'Enrolled ✓',
  watchNow: lang === 'ar' ? 'شاهد الكورس' : 'Watch Course',
  lessons: lang === 'ar' ? 'الحلقات' : 'Lessons',
  free: lang === 'ar' ? 'مجاني' : 'Free',
  introVideo: lang === 'ar' ? 'فيديو تعريفي' : 'Introduction Video',
  freePreview: lang === 'ar' ? 'معاينة مجانية' : 'Free Preview',
  courseContent: lang === 'ar' ? 'محتوى الكورس' : 'Course Content',
  pendingPayments: lang === 'ar' ? 'مدفوعات في الانتهار' : 'Pending Payments',
  approve: lang === 'ar' ? 'تفعيل' : 'Activate',
  reject: lang === 'ar' ? 'رفض' : 'Reject',
  method_card: lang === 'ar' ? 'فيزا' : 'Card',
  method_transfer: lang === 'ar' ? 'تحويل' : 'Transfer',
  method_vodafone: lang === 'ar' ? 'فودافون' : 'Vodafone',
  manageEmployees: lang === 'ar' ? 'إدارة الموظفين' : 'Manage Employees',
  addEmployee: lang === 'ar' ? 'إضافة موظف' : 'Add Employee',
  editEmployee: lang === 'ar' ? 'تعديل موظف' : 'Edit Employee',
  employeeUsername: lang === 'ar' ? 'اسم المستخدم' : 'Username',
  employeePassword: lang === 'ar' ? 'كلمة المرور' : 'Password',
  employeePasswordHint: lang === 'ar' ? 'اتركها فارغة للإبقاء على القديمة' : 'Leave empty to keep current',
  employeeRole: lang === 'ar' ? 'الوظيفة' : 'Role',
  employeeActive: lang === 'ar' ? 'نشط' : 'Active',
  employeeInactive: lang === 'ar' ? 'موقوف' : 'Suspended',
  cannotDelSelf: lang === 'ar' ? 'لا يمكن حذف حسابك الحالي' : 'Cannot delete your own account',
  manageRoles: lang === 'ar' ? 'إدارة الوظائف' : 'Manage Roles',
  addRole: lang === 'ar' ? 'إضافة وظيفة' : 'Add Role',
  editRole: lang === 'ar' ? 'تعديل وظيفة' : 'Edit Role',
  roleNameAr: lang === 'ar' ? 'اسم الوظيفة (عربي)' : 'Role Name (Arabic)',
  roleNameEn: lang === 'ar' ? 'اسم الوظيفة (إنجليزي)' : 'Role Name (English)',
  defaultPerms: lang === 'ar' ? 'الصلاحيات الافتراضية' : 'Default Permissions',
  delRoleConfirm: lang === 'ar' ? 'سيتم حذف الوظيفة' : 'Role will be deleted',
  myCourses: lang === 'ar' ? 'كورساتي' : 'My Courses',
  myCoursesTitle: lang === 'ar' ? 'كورساتي المشترك فيها' : 'My Enrolled Courses',
  noEnrolledCourses: lang === 'ar' ? 'مش مشترك في أي كورس لحد دلوقتي' : 'You are not enrolled in any courses yet',
  browseCoursesBtn: lang === 'ar' ? 'تصفح الكورسات' : 'Browse Courses',
  startLearning: lang === 'ar' ? 'ابدأ المشاهدة' : 'Start Watching',
  continueLearning: lang === 'ar' ? 'كمّل المشاهدة' : 'Continue Watching',
  contactSend: lang === 'ar' ? 'إرسال الرسالة' : 'Send Message',
  contactSending: lang === 'ar' ? 'جاري الإرسال...' : 'Sending...',
  contactDone: lang === 'ar' ? '✅ تم إرسال رسالتك! هنرد عليك قريباً' : '✅ Message sent! We will reply shortly',
  contactInfo: lang === 'ar' ? 'بيانات التواصل' : 'Contact Info',
  contactAddress: lang === 'ar' ? 'العنوان' : 'Address',
  contactHours: lang === 'ar' ? 'ساعات العمل' : 'Working Hours',
  contactHoursVal: lang === 'ar' ? 'السبت — الخميس: 9ص — 6م' : 'Sat — Thu: 9AM — 6PM',
  contactSocial: lang === 'ar' ? 'تابعنا على' : 'Follow Us',
  contactMessages: lang === 'ar' ? 'رسائل التواصل' : 'Contact Messages',
  serviceOptions: lang === 'ar'
    ? ['تطوير مواقع', 'تطوير تطبيقات', 'تسويق رقمي', 'تصميم UI/UX', 'كورس تدريبي', 'استفسار عام']
    : ['Web Development', 'Mobile Apps', 'Digital Marketing', 'UI/UX Design', 'Training Course', 'General Inquiry'],
  permLabels: {
    can_view_dashboard:   lang === 'ar' ? '📊 لوحة التحكم'      : '📊 Dashboard',
    can_manage_courses:   lang === 'ar' ? '🎓 إدارة الكورسات'   : '🎓 Manage Courses',
    can_manage_lessons:   lang === 'ar' ? '🎬 إدارة الحلقات'    : '🎬 Manage Lessons',
    can_manage_services:  lang === 'ar' ? '💼 إدارة الخدمات'    : '💼 Manage Services',
    can_view_customers:   lang === 'ar' ? '👥 عرض العملاء'      : '👥 View Customers',
    can_view_enrollments: lang === 'ar' ? '✅ عرض الاشتراكات'   : '✅ View Enrollments',
    can_manage_employees: lang === 'ar' ? '👨‍💼 إدارة الموظفين' : '👨‍💼 Manage Employees',
    can_manage_settings:  lang === 'ar' ? '⚙️ إعدادات الموقع'  : '⚙️ Site Settings',
  },
});

// ── Cache للـ custom labels ────────────────────────────────
let _cache = null;
let _cacheTime = 0;
const CACHE_TTL = 5 * 60 * 1000; // 5 دقايق

export const loadCustomLabels = async () => {
  if (_cache && Date.now() - _cacheTime < CACHE_TTL) return _cache;
  try {
    const { data } = await supabase.from('custom_labels').select('key, ar_value, en_value');
    _cache = data || [];
    _cacheTime = Date.now();
    return _cache;
  } catch { return []; }
};

export const clearLabelsCache = () => { _cache = null; };

// ── TR مع دعم custom labels ─────────────────────────────
export const TR = (lang, site, customLabels = []) => {
  const defaults = DEFAULTS(lang, site);
  if (!customLabels.length) return defaults;

  const overrides = {};
  customLabels.forEach(l => {
    overrides[l.key] = lang === 'ar' ? l.ar_value : l.en_value;
  });

  return { ...defaults, ...overrides };
};

// ── كل المصطلحات أوتوماتيك من DEFAULTS (للـ Labels Manager) ──────────
// أي مسمى موجود في البرنامج بيظهر تلقائيًا — مفيش قايمة يدوية
// التصنيف بيتحدد من اسم المفتاح
const guessCat = (key) => {
  const k = key.toLowerCase();
  if (/(login|register|logout|guest|password|username|account|auth|emp|cust|otp|forgot|reset)/.test(k)) return 'auth';
  if (/(pay|price|card|wallet|transfer|coupon|instapay|approve|reject|amount|invoice|receipt)/.test(k)) return 'payment';
  if (/(course|lesson|enroll|watch|learn|free|instructor|category|review|rating|student|work)/.test(k)) return 'courses';
  if (/(manage|add|edit|delete|admin|dashboard|employee|role|settings|report|label|knowledge)/.test(k)) return 'admin';
  if (/(academy|agency|contact|home|nav|site|subtitle|back|my)/.test(k)) return 'nav';
  return 'general';
};

// ترتيب التصنيفات للعرض
const _CAT_ORDER = { nav: 1, courses: 2, payment: 3, auth: 4, admin: 5, general: 6 };

export const ALL_LABEL_KEYS = (() => {
  const ar = DEFAULTS('ar', '');
  const en = DEFAULTS('en', '');
  const list = [];
  Object.keys(ar).forEach(key => {
    const arVal = ar[key];
    // نتجاهل أي قيمة مش نص (زي services array و permLabels object)
    if (typeof arVal !== 'string') return;
    const enVal = typeof en[key] === 'string' ? en[key] : arVal;
    list.push({ key, ar: arVal, en: enVal, cat: guessCat(key) });
  });
  // ترتيب حسب التصنيف ثم الاسم
  list.sort((a, b) => (_CAT_ORDER[a.cat] - _CAT_ORDER[b.cat]) || a.key.localeCompare(b.key));
  return list;
})();

export const CAT_LABELS = {
  nav:     '🧭 التنقل والعناوين',
  courses: '🎓 الكورسات',
  payment: '💳 الدفع',
  auth:    '🔑 الحسابات',
  admin:   '⚙️ الإدارة',
  general: '📝 عام',
};
